module.exports = __webpack_public_path__ + "static/img/gptModel31.8de0c473.png";